<div class="modal-editions" cdkTrapFocus cdkTrapFocusAutoCapture>
  Hello from modal editions
</div>
